import type { GetModelComponentsInput, ModelComponentCreateDto, ModelComponentDto, ModelComponentUpdateDto, ModelComponentWithNavigationPropertiesDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class ModelComponentService {
  apiName = 'Inventory';

  create = (input: ModelComponentCreateDto) =>
    this.restService.request<any, ModelComponentDto>({
      method: 'POST',
      url: '/api/inventory/model-components',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/model-components/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ModelComponentDto>({
      method: 'GET',
      url: `/api/inventory/model-components/${id}`,
    },
    { apiName: this.apiName });

  getAssetModelLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/model-components/asset-model-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getComponentLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/model-components/component-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetModelComponentsInput) =>
    this.restService.request<any, PagedResultDto<ModelComponentWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/model-components',
      params: { filterText: input.filterText, countMin: input.countMin, countMax: input.countMax, assetModelId: input.assetModelId, componentId: input.componentId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, ModelComponentWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/model-components/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: ModelComponentUpdateDto) =>
    this.restService.request<any, ModelComponentDto>({
      method: 'PUT',
      url: `/api/inventory/model-components/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
